import React, { useCallback, useState }  from 'react';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';

// import { useIdParam } from '$/hooks';
// import { useToaster } from '@amzn/dots-core-ui';

import { CorePage, CorePageTitle } from '$/components';

import { RootUri, CrashModelUri } from '$/features/routes';
import { CrashModelDetailForm, CrashModelInputForm } from './components';

export type CrashModelApiInput = {
    crash_model_id: string;
    numlines: number;
};

export const CrashModelSearchPage = (): JSX.Element => {
  // const id = useIdParam();
  const [crashId, setCrashId] = useState('');
  const [numLines, setnumLines] = useState(50);
  console.log(numLines);
  const onSubmit = useCallback(
    (input) => {
      setCrashId(input.crash_model_id);
      setnumLines(input.numlines);
    },
    []
  );
  return (
    <CorePage
      title={'Search for CrashModel'}
      breadcrumbs={[
        { title: 'KOKO', href: RootUri },
        { title: 'Crash Models', href: CrashModelUri },
      ]}
      header={
        <Row widths={['fill', 'fit']}>
          <Column>
            <CorePageTitle title={'Search for a Crash Model!'} />
          </Column>
        </Row>
      }
    >
    <Row widths="grid-6" alignmentVertical="top" spacing="large">
      <Column>
        <CrashModelInputForm onSubmit={onSubmit}/>
      </Column>
    </Row>
    {crashId  && (
        <CrashModelDetailForm crash_model_id={crashId}/>
    )}
    
    </CorePage>
  );
};
